import { SvgIconProps } from '@mui/material';

export function SurchargeMoonIcon(props: SvgIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5302 15.9304C21.3702 15.6604 20.9202 15.2404 19.8002 15.4404C19.1802 15.5504 18.5502 15.6004 17.9202 15.5704C15.5902 15.4704 13.4802 14.4004 12.0102 12.7504C10.7102 11.3004 9.9102 9.41036 9.9002 7.37036C9.9002 6.23036 10.1202 5.13036 10.5702 4.09036C11.0102 3.08036 10.7002 2.55036 10.4802 2.33036C10.2502 2.10036 9.7102 1.78036 8.6502 2.22036C4.5602 3.94036 2.0302 8.04036 2.3302 12.4304C2.6302 16.5604 5.5302 20.0904 9.3702 21.4204C10.2902 21.7404 11.2602 21.9304 12.2602 21.9704C12.4202 21.9804 12.5802 21.9904 12.7402 21.9904C16.0902 21.9904 19.2302 20.4104 21.2102 17.7204C21.8802 16.7904 21.7002 16.2004 21.5302 15.9304Z"
        fill="#FF796E"
      />
    </svg>
  );
}

export default SurchargeMoonIcon;
